var _style, _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeposit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.7 110.7",
    style: {
      enableBackground: "new 0 0 110.7 110.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#545554;enable-background:new    ;}\n\t.st1{font-family:'ArialUnicodeMS';}\n\t.st2{font-size:20.0236px;}\n\t.st3{fill:#545554;}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 19.3433 85.9521)",
    className: "st0 st1 st2"
  }, "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1D\u0E32\u0E01")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.8,87.3c-13.9,0-27.7,0-41.7,0c0-11.2,0-22.3,0-33.6c0.5,0,0.7,0,1.2,0c10.6,0,21,0,31.7,0 c1.6,0,2.7-0.5,3.7-1.9c1.4-2,2.9-4,4.4-6c0.1-0.4,0.4-0.5,0.6-0.7C62.8,59.3,62.8,73.3,62.8,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.1,41.9c0,15.2,0,30.1,0,45.3c-3.4,0-6.7,0-10.2,0c0-15.2,0-30.1,0-45.3C69.2,41.9,72.6,41.9,76.1,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.9,50.5c2.1-2.9,4.2-5.6,6.3-8.3c0.1-0.4,0.6-0.4,1.1-0.4c6.1,0,12.1,0,18.2,0c6.2,0,12.4,0,18.7,0 c0.4,0,0.6,0,1.1,0c-0.1,0.4-0.4,0.5-0.5,0.7c-1.9,2.5-3.6,5-5.6,7.5c-0.4,0.4-0.7,0.6-1.1,0.6c-12.4,0-25,0-37.4,0 C16.5,50.8,16.4,50.8,15.9,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.5,28.6c1.1,0.7,2.1,1.5,3.4,2.5c-3.4,0.9-6.5,1.9-9.8,2.7c0-2.9,0-5.7,0-8.6c1.2,0.6,2.2,1.2,3.4,1.9 c6.8-7.6,15.3-10.7,25.4-9.2c7.6,1.1,13.9,4.2,18.2,10.7c8.8,13.3,5.3,29.4-6,38.1c-0.7-0.9-1.4-1.6-2.1-2.6 c6.7-5.3,10.2-12.3,9.7-20.8C91.4,36.4,89,30.4,83.7,26C73.3,17.8,57.7,18.5,49.5,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.5,38.9c-1.4,0-2.5,0-3.5,0c-3,0-6,0-9,0c-0.4,0-0.7-0.1-0.9-0.4c-1.5-2.2-2.9-4.4-4.4-6.8 c0.4,0,0.6,0,0.9,0c3.6,0,7.2,0,10.9,0c0.6,0,0.9,0.1,1.2,0.6C32.4,34.5,33.9,36.6,35.5,38.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeposit);
export default __webpack_public_path__ + "static/media/ic_deposit.9f900cc4a13630bca81cd1baf80ed8f3.svg";
export { ForwardRef as ReactComponent };